import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import TilingAware from 'src/app/model/helper-interfaces/tiling-aware';

@Component({
  selector: 'app-tiling',
  templateUrl: './tiling.component.html',
  styleUrls: ['./tiling.component.scss'],
})
export class TilingComponent implements OnInit {
  checkHorizontalTiling: boolean = false;
  checkVerticalTiling: boolean = false;
  tilingChecked: boolean;

  @Input()
  public inputTilingAware: TilingAware;
  @Output()
  public output = new EventEmitter();

  constructor() {}

  ngOnInit() {
    this.checkHorizontalTiling = this.inputTilingAware.numTilingHorizontal > 0;
    this.checkVerticalTiling = this.inputTilingAware.numTilingVertical > 0;
    this.tilingChecked = this.inputTilingAware.tiling === false;
  }

  noTilingChanged() {
    if (!this.tilingChecked) {
      this.inputTilingAware.tiling =
        this.inputTilingAware.numTilingHorizontal > 0 ||
        this.inputTilingAware.numTilingVertical > 0
          ? true
          : null;
    } else {
      this.inputTilingAware.tiling = false;
    }
    if (!this.inputTilingAware.tiling) {
      this.checkHorizontalTiling = false;
      this.checkVerticalTiling = false;
      delete this.inputTilingAware.numTilingHorizontal;
      delete this.inputTilingAware.numTilingVertical;
    }
    this.output.emit();
  }

  horizontalTilingCheckChanged(event) {
    this.checkHorizontalTiling = event;
    if (event) {
      this.tilingChecked = false;
    }
    if (event === false) {
      this.inputTilingAware.numTilingHorizontal = null;
      if (
        this.inputTilingAware.numTilingVertical == null ||
        this.inputTilingAware.numTilingVertical <= 0
      ) {
        this.inputTilingAware.tiling = null;
      }
    }
    this.output.emit();
  }

  numHorizontalTiling(event) {
    if (this.inputTilingAware.numTilingHorizontal > 0) {
      this.inputTilingAware.tiling = true;
      this.tilingChecked = false;
    } else {
      this.checkHorizontalTiling = false;
      if (
        this.inputTilingAware.numTilingVertical == null ||
        this.inputTilingAware.numTilingVertical <= 0
      ) {
        this.checkVerticalTiling = false;
        this.inputTilingAware.tiling = false;
        this.tilingChecked = true;
      }
    }
    this.output.emit();
  }

  verticalTilingCheckChanged(event) {
    this.checkVerticalTiling = event;
    if (event) {
      this.tilingChecked = false;
    }
    if (event === false) {
      this.inputTilingAware.numTilingVertical = null;
      if (
        this.inputTilingAware.numTilingHorizontal == null ||
        this.inputTilingAware.numTilingHorizontal <= 0
      ) {
        this.inputTilingAware.tiling = null;
      }
    }
    this.output.emit();
  }

  numVerticalTiling(event) {
    if (this.inputTilingAware.numTilingVertical > 0) {
      this.inputTilingAware.tiling = true;
      this.tilingChecked = false;
    } else {
      this.checkVerticalTiling = false;
      if (
        this.inputTilingAware.numTilingHorizontal == null ||
        this.inputTilingAware.numTilingHorizontal <= 0
      ) {
        this.checkHorizontalTiling = false;
        this.inputTilingAware.tiling = false;
        this.tilingChecked = true;
      }
    }
    this.output.emit();
  }
}
